import { MockHttpResponse } from 'src/app/core/models';

export const submitReorder = () => ({});
export const submitShipment = () => ({});

export const submitReorderError = (): MockHttpResponse<any> => ({
  responseHttpStatus: 200,
  responseBody: {
    success: false,
    returnCode: 400,
    messages: [],
    errors: ['Physician Visit Date is too old.'],
    rowCount: 0,
    data: { canCreateShipment: false, info: [], stdConfigUpdateStatus: false },
  },
});
